<style>

.uk-sticky-placeholder {
    margin-top: -40px;
    width: 100%;
}
</style>
<style scoped lang="scss">
.assistance-toggle-label {
  font-size: 1.4em;
  display: flex;

  .checkbox-container {
    display: flex;
    flex: 0 0 33px;
    align-items: center;
    justify-content: space-between;
  }

  span {
    margin-left: 8px;
  }

  input[type="checkbox"] {
    transform: scale(1.4);
  }
}
.small-input {
    max-width: 104px;
  }
.light-green {
  background-color: #bfffbf !important;
}
.light-red {
  background-color: #fdaaaa !important;
}

.eligibility-divider {
  border-bottom: thick dashed black !important;
  margin-bottom: 8px;
}
</style>

<template>
  <div v-if="application">
    <div class="uk-display-inline-block uk-width-1-1">
    <h2 class="uk-margin-bottom-remove">
        {{ getAssistanceLabel(type) }}
      <span style="font-size: 0.8em; cursor: pointer" v-if="permissions.processor && !isLocked">
        <button
          class="uk-align-right uk-button uk-button-link"
          style="font-size: 0.8em; color: #bbb"
          @click="openHistory"
        >
          <i class="a-rotate-left"></i>
          {{ __('global.restore') }}
        </button>
      </span>
    </h2>
      <h4>
        <validated-section :errors="formErrors" :field="'unit_ledger_entries.'+this.type.id+'.duplicate'">
          &nbsp;
        </validated-section>
      </h4>
    <h4 v-if="type.description !== null" style="margin-top: 0px !important">
      {{ type.description }}
    </h4>
    <div class="uk-text-muted uk-margin-top-remove uk-margin-bottom" v-if="vendor">
      {{ __('tenant.vendor') }} #{{ vendorId }}: {{ vendor.organization_name }}
    </div>
    </div>
    <div class="uk-grid">
      <div class="uk-width-1-1">
        <label class="assistance-toggle-label">
          <div class="checkbox-container">
            <input
              class="uk-checkbox"
              checked
              type="checkbox"
              v-model="needsAssistance"
              :disabled="disableAssistanceCheckbox"
              @change="onNeedAssistanceChange"
            />
            <label v-if="disableAssistanceCheckbox">
              <i class="uk-icon-question" uk-tooltip title="You can't remove utilies with payment or shared records."></i>
            </label>
          </div>
          <div>
            <span>{{ getCheckboxText(type) }}</span>
          </div>
        </label>
      </div>

      <div class="uk-width-1-1 uk-margin-top" v-if="needsAssistance">
        <template>
          <div class="uk-grid">
            <!-- Who is it paid to? -->
            <div class="uk-width-small-1-1 uk-width-medium-1-3" v-if="(type.is_utility && type.pivot.type !== 5) || type.key == 'mortgage'">
              <fieldset>
                <label>{{ __("tenant.who_is_this_bill") }}</label>
                <div>
                  <validated-section :errors="errors" field="vendorId">
                    <autocomplete
                      class="form-autocomplete"
                      ref="autocomplete"
                      :aria-label="__('tenant.who_is_this_bill')"
                      :debounce-time="200"
                      :get-result-value="getResultValue"
                      :placeholder="'Find Vendor'"
                      :search="searchVendors"
                      @blur="setVendorFromTextValue"
                      @focus="vendor = null"
                      @submit="setVendor"
                    >
                      <template #result="{ result, props }">
                        <li v-bind="props">
                          <p>
                            #{{ result.id }} - {{ result.organization_name }}
                            <span v-if="result.uses_cdf && permissions.processor">(CDF)</span>
                          </p>
                        </li>
                      </template>
                    </autocomplete>
                  </validated-section>
                </div>
              </fieldset>
            </div>

            <!-- Who pays it? -->
            <div class="uk-width-small-1-1 uk-width-medium-1-3" v-show="type.pivot.type != TYPE_LEDGER_SIMPLIFIED || !programSettings['disable-who-pays-this-bill-option']">
              <fieldset>
                <label>{{ __("tenant.who_pays_bill") }}</label>
                <div>
                  <validated-section :errors="errors" field="hhMemberId">
                    <select
                      :aria-label="__('tenant.who_pays_bill')"
                      class="uk-input uk-select uk-form-large uk-width-1-1"
                      v-model="hhMemberId"
                    >
                      <option :value="null">
                        {{ __("tenant.select_household_member") }}
                      </option>
                      <option v-for="member in application.household.members" :key="member.id" :value="member.id">
                        {{ member.first_name }}
                        {{ member.last_name }}
                      </option>
                    </select>
                  </validated-section>
                </div>
              </fieldset>
            </div>

            <!-- Disconnected? -->
            <div class="uk-width-small-1-1 uk-width-medium-1-3" v-show="type.is_utility && type.pivot.type != 4 && type.pivot.type != 5">
              <fieldset>
                <label class="">{{ __("tenant.utility_disconnected") }}</label>
                <br />
                <validated-section :errors="errors" field="disconnectStatusId">
                  <select
                    :aria-label="__('tenant.utility_disconnected')"
                    v-model="disconnectStatusId"
                    required
                    class="uk-width-1-1 uk-select uk-form-large"
                  >
                    <option :value="null" selected>_</option>
                    <option v-for="item in assets.disconnectedStatus" :key="item.id" :value="item.id">
                      {{ item.disconnected_statuse_desc }}
                    </option>
                  </select>
                </validated-section>
              </fieldset>
            </div>
          </div>

          <div class="uk-grid" v-if="(type.is_utility  || type.key == 'mortgage') && type.pivot.type != 5" >
            <!-- Account Number -->
            <div class="uk-width-small-1-1 uk-width-medium-1-3">
              <fieldset>
                <label class="">{{ __("tenant.account_number") }}</label>
                <br />
                <validated-section :errors="errors" field="accountNumber">
                  <input
                    class="uk-form-large uk-width-1-1"
                    type="text"
                    v-model="accountNumber"
                    :aria-label="__('tenant.account_number')"
                  />
                </validated-section>
              </fieldset>
            </div>

            <!-- Account Number Confirmation -->
            <div class="uk-width-small-1-1 uk-width-medium-1-3" v-show="type.is_utility  || type.key == 'mortgage'">
              <fieldset>
                <label class="">{{ __("tenant.confirm_account_number") }}</label>
                <br />
                <validated-section field="accountNumberConfirmation" :errors="errors">
                  <input
                    class="uk-form-large uk-width-1-1"
                    type="text"
                    v-model="accountNumberConfirmation"
                    :aria-label="__('tenant.confirm_account_number')"
                  />
                </validated-section>
              </fieldset>
            </div>
          </div>
        </template>
      </div>

      <div class="uk-width-1-1 uk-margin-top">
        <slot v-if="needsAssistance" />
      </div>

      <div class="uk-width-1-1 uk-margin-top" v-if="(type.pivot.type === 1 || type.pivot.type === 4 || type.pivot.type === 5 ) && needsAssistance && canShowLedger">
        <div class="uk-sticky-container uk-overflow-container uk-hidden-small uk-grid-width-medium-1-1" style="position: relative;">
          <table :data-uk-sticky="permissions.processor ? 'offset: 115' : 'end: true;'" style="padding-bottom: 120px;" class="uk-table uk-table-divider uk-table-striped sticky-header" :summary="`${type.name} details`">
            <thead >
              <tr style="background-color: white;">
                <th scope="col"  class="uk-text-left">
                    {{ __('tenant.month') }}<span v-if="futureMonths() > 1">*</span>
                </th>
                <th scope="col" style="width: 12%;" class="uk-text-right">
                  {{ programSettings["ledger-title-amount-due"] }}
                </th>
                <th scope="col" style="width: 12%;" class="uk-text-right" v-if="type.pivot.type !== TYPE_LEDGER_SIMPLIFIED">
                  {{ programSettings["ledger-title-amount-paid"] }}
                </th>
                <th scope="col" style="width: 12%;" class="uk-text-right"
                    v-if="program.settings['uses-ledger-entry-fees'] && type.pivot.type !== TYPE_LEDGER_SIMPLIFIED"
                >
                  {{ programSettings["ledger-title-amount-fees-due"] }}
                  <span v-if="type.pivot.max_fee_amount" class="uk-text-muted">
                    (Max {{ type.pivot.max_fee_amount | formatMoney }})
                  </span>
                </th>
                <th scope="col" style="width: 12%;" class="uk-text-right"
                    v-if="showAlternativeFunding && type.pivot.type !== TYPE_LEDGER_SIMPLIFIED"
                >
                  {{ __("tenant.amount_paid_other") }}
                  <a
                    class="uk-dark uk-light use-hand-cursor theme-primary-bg-color uk-float-right"
                    onclick="UIkit.modal.alert('<div class=\'uk-grid\'><div class=\'uk-width-1-1 uk-margin-bottom\'><h3>If you have received assistance from another government program specifically for rent or utilities, please enter that amount here. (Do not include rent subsidies from programs like Section 8).</h3></div></div>');"
                    style="
                      margin-right: 110px;
                      font-size: 14px;
                      background-color: #6495d1;
                      width: 20px;
                      height: 20px;
                      display: block;
                      border-radius: 10px;
                      text-align: center;
                      color: white;
                    "
                    title="WHAT DOES THIS MEAN?"
                    uk-tooltip
                    v-if="programSettings['show-housing-help-button']"
                    >?</a
                  >
                </th>
                <th scope="col" style="width: 12%;" class="uk-text-right" v-if="type.pivot.type !== TYPE_LEDGER_SIMPLIFIED">
                  {{ programSettings["ledger-title-amount-total-requested"] }}
                </th>
                <th scope="col" style="width: 12%;" class="uk-text-right" v-if="showApproved">{{ __("tenant.approved") }}</th>
                <th scope="col" style="width: 12%;" class="uk-text-right" v-if="showPaid">{{ __("tenant.paid") }}</th>
              </tr>
            </thead>
          </table>
          <table class="uk-table uk-table-divider uk-table-striped" style="margin-top: 30px;">
            <tbody>
              <template v-for="(month, key) in months">
                <tr :class="getClassForMonth(month)" :key="key">
                  <td class="uk-text-left">
                    <input
                      v-if="getValueForMonth(month, 'own_ule') || !monthInputs[month.format(monthFormat)]"
                      v-model="checkedMonths"
                      type="checkbox"
                      :ref="'input_'+month"
                      :aria-label="month.format('MMM YYYY')"
                      :disabled="getValueForMonth(month, 'has_payment') !== 0"
                      :value="month.format(monthFormat)"
                      @change="onMonthCheckedChange(month, $event)"
                    />
                    <button
                      aria-label="confirm transfer"
                      v-else-if="
                        permissions.processor &&
                        !getValueForMonth(month, 'own_ule') &&
                        !getValueForMonth(month, 'has_payment') &&
                        monthInputs[month.format(monthFormat)]
                      "
                      @click="transferRecord(month)"
                    >
                      <i class="uk-icon-forward use-hand-cursor" uk-tooltip  title="Transfer thiscord"></i>
                    </button>
                    <a
                      v-if="monthInputs[month.format(monthFormat)]"
                      href="javascript:;"
                      :aria-label="getTooltipForMonth(month)"
                    >
                      <i class="uk-icon-info" uk-tooltip :title="getTooltipForMonth(month)"></i>
                    </a>
                    {{ month.format("MMM YYYY") }}
                  </td>
                  <td style="width: 12%;" class="uk-text-right">
                    <div
                      v-if="
                        getValueForMonth(month, 'own_ule') &&
                        checkedMonths.includes(month.format(monthFormat)) &&
                        monthInputs[month.format(monthFormat)] &&
                        !getValueForMonth(month, 'has_payment') &&
                        canEditLedgerAmounts
                      "
                    >
                      <input
                        v-if="canChangeAmount && usingScreenReader"
                        :aria-label="programSettings['ledger-title-amount-due']"
                        :value="getValueForMonth(month, 'amount')"
                        @change="updateValueForMonth(month, 'amount', $event.target.value)"
                      />
                      <currency-input
                        v-else-if="canChangeAmount && !usingScreenReader"
                        :currency="{ prefix: '$ ' }"
                        :value="getValueForMonth(month, 'amount')"
                        @change="updateValueForMonth(month, 'amount', $event)"
                        class="small-input"
                      />
                      <span v-else class="uk-text-right">
                        {{ getValueForMonth(month, "amount") | formatMoney }}
                      </span>
                    </div>
                    <div
                      v-else-if="
                        checkedMonths.includes(month.format(monthFormat)) && monthInputs[month.format(monthFormat)]
                      "
                    >
                      {{ getValueForMonth(month, "amount") | formatMoney }}
                    </div>
                    <span v-else>-</span>
                  </td>
                  <td class="uk-text-right" style="width: 12%;" v-if="type.pivot.type !== TYPE_LEDGER_SIMPLIFIED">
                    <div
                      v-if="
                        getValueForMonth(month, 'own_ule') &&
                        checkedMonths.includes(month.format(monthFormat)) &&
                        monthInputs[month.format(monthFormat)] &&
                        !getValueForMonth(month, 'has_payment') &&
                        canEditLedgerAmounts
                      "
                    >
                      <input
                        v-if="canChangeAmount && usingScreenReader"
                        :aria-label="programSettings['ledger-title-amount-paid']"
                        :value="getValueForMonth(month, 'paid')"
                        @change="updateValueForMonth(month, 'paid', $event.target.value)"
                      />
                      <currency-input
                        v-else-if="canChangeAmount && !usingScreenReader"
                        :aria-label="programSettings['ledger-title-amount-paid']"
                        :currency="{ prefix: '$ ' }"
                        :value="getValueForMonth(month, 'paid')"
                        @change="updateValueForMonth(month, 'paid', $event)"
                        class="small-input"
                      />
                      <span v-else class="uk-text-right">
                        {{ getValueForMonth(month, "paid") | formatMoney }}
                      </span>
                    </div>
                    <div
                      v-else-if="
                        checkedMonths.includes(month.format(monthFormat)) && monthInputs[month.format(monthFormat)]
                      "
                    >
                      {{ getValueForMonth(month, "paid") | formatMoney }}
                    </div>
                    <span v-else>-</span>
                  </td>
                  <td class="uk-text-right" style="width: 12%;" v-if="program.settings['uses-ledger-entry-fees'] && type.pivot.type !== TYPE_LEDGER_SIMPLIFIED">
                    <div
                      v-if="
                        getValueForMonth(month, 'own_ule') &&
                        checkedMonths.includes(month.format(monthFormat)) &&
                        monthInputs[month.format(monthFormat)] &&
                        !getValueForMonth(month, 'has_payment') &&
                        canEditLedgerAmounts
                      "
                    >
                      <input
                        v-if="canChangeAmount && usingScreenReader"
                        :aria-label="programSettings['ledger-title-amount-fees-due']"
                        :value="getValueForMonth(month, 'fees')"
                        @change="updateValueForMonth(month, 'fees', $event.target.value)"

                      />
                      <currency-input
                        :currency="{ prefix: '$ ' }"
                        v-else-if="canChangeAmount && !usingScreenReader"
                        :id="`${type}-currency-input-${programSettings['ledger-title-amount-fees-due']}`"
                        :value="getValueForMonth(month, 'fees')"
                        @change="updateValueForMonth(month, 'fees', $event)"
                        class="small-input"
                      />
                      <span v-else class="uk-text-right">
                        {{ getValueForMonth(month, "fees") | formatMoney }}
                      </span>
                    </div>
                    <div
                      v-else-if="
                        checkedMonths.includes(month.format(monthFormat)) && monthInputs[month.format(monthFormat)]
                      "
                    >
                      {{ getValueForMonth(month, "fees") | formatMoney }}
                    </div>
                    <span v-else>-</span>
                  </td>
                  <td class="uk-text-right" style="width: 12%;" v-if="showAlternativeFunding && type.pivot.type !== TYPE_LEDGER_SIMPLIFIED">
                    <div
                      v-if="
                        getValueForMonth(month, 'own_ule') &&
                        checkedMonths.includes(month.format(monthFormat)) &&
                        monthInputs[month.format(monthFormat)]
                      "
                    >
                      <validated-section :errors="errors" :field="`month_${key}_program_${id}_alternative_fund`">
                        <div style="display: flex; flex-direction: row; align-items: center; justify-items: center">
                          <button
                            class="uk-button uk-button-link"
                            v-if="canEditLedgerAmounts && usingScreenReader"
                            @click="addAssistance(monthInputs[month.format(monthFormat)].alternative_funding_programs)"
                          >
                            <i class="a-circle-plus"></i>
                            {{ __("tenant.report_other_funding") }}
                          </button>
                          <div
                            class="uk-margin-bottom"
                            v-for="(program, i) in getArrayValueForMonth(month, 'alternative_funding_programs')"
                            :key="`${type.name}-program-${i}`"
                          >
                            <input
                              v-if="usingScreenReader"
                              v-model="program.pivot.amount"
                              :aria-label="`${__('tenant.amount_paid_other')}`"
                            />
                            <currency-input v-else v-model="program.pivot.amount" :currency="{ prefix: '$ ' }" class="small-input" />
                            <select
                              class="uk-input uk-select"
                              placeholder="Select Source"
                              style="width: 175px"
                              v-model="program.pivot.alternative_funding_program_id"
                              :aria-label="__('tenant.other_programs')"
                            >
                              <option :value="null">Choose a Source...</option>
                              <option
                                v-for="_program in alternativeFundingPrograms"
                                :key="_program.id"
                                :value="_program.id"
                              >
                                {{ _program.name }}
                              </option>
                            </select>
                            <button
                              aria-label="Remove"
                              class="uk-text-danger uk-button uk-button-link"
                              v-if="canEditLedgerAmounts && !usingScreenReader"
                              @click="monthInputs[month.format(monthFormat)].alternative_funding_programs.splice(i, 1)"
                            >
                              <i class="a-trash-2"></i>
                            </button>
                          </div>
                          <button
                            class="uk-button uk-button-link"
                            v-if="canEditLedgerAmounts"
                            @click="addAssistance(monthInputs[month.format(monthFormat)].alternative_funding_programs)"
                          >
                            <i class="a-circle-plus"></i>
                            {{ __("tenant.report_other_funding") }}
                          </button>
                        </div>
                      </validated-section>
                    </div>
                    <span v-else>-</span>
                  </td>
                  <td class="uk-text-right" style="width: 12%;" v-if="type.pivot.type !== TYPE_LEDGER_SIMPLIFIED">
                    <div
                      class="uk-text-right"
                      tabindex="0"
                      v-if="checkedMonths.includes(month.format(monthFormat))"
                      :aria-label="`${
                        programSettings['ledger-title-amount-total-requested']
                      } $${getRequestedAssistanceForMonth(month)}`"
                    >
                      {{ getRequestedAssistanceForMonth(month) | formatMoney }}
                    </div>
                    <span v-else>-</span>
                  </td>
                  <td style="width: 12%;" v-if="showApproved" class="uk-text-right">
                      <span
                              v-if="
                          checkedMonths.includes(month.format(monthFormat)) && monthInputs[month.format(monthFormat)]
                        "
                      >
                        <span v-if="getValueForMonth(month, 'own_ule') && !getValueForMonth(month, 'has_payment')">
                          <input
                                  v-if="usingScreenReader"
                                  :value="getValueForMonth(month, 'approved')"
                                  @change="updateValueForMonth(month, 'approved', $event.target.value)"
                          />
                          <currency-input
                                  v-else
                                  :currency="{ prefix: '$ ' }"
                                  :value="getValueForMonth(month, 'approved')"
                                  @change="updateValueForMonth(month, 'approved', $event)"
                                  class="small-input"
                          />
                        </span>
                        <span v-else>
                          {{ getValueForMonth(month, "approved") | formatMoney }}
                        </span>
                      </span>
                        <span v-else>-</span>
                    </td>
                  <td style="width: 12%;" v-if="showPaid" class="uk-text-right">
                      <span
                              v-if="
                          checkedMonths.includes(month.format(monthFormat)) && monthInputs[month.format(monthFormat)]
                        "
                      >
                        {{ getValueForMonth(month, "paid_by_sponsor") | formatMoney }}
                      </span>
                        <span v-else>-</span>
                    </td>
                </tr>
                <tr v-if="permissions.processor && showLLEdit(month)" class="color-green" style="font-weight: bold">
                  <td>LL Edit</td>
                  <td class="uk-text-right">
                    <div v-if="getValueForMonth(month, 'landlord_edited_amount') != getValueForMonth(month, 'amount')">
                      {{ getValueForMonth(month, "landlord_edited_amount") | formatMoney }}
                    </div>
                  </td>
                  <td class="uk-text-right">
                    <div v-if="getValueForMonth(month, 'landlord_edited_paid') != getValueForMonth(month, 'paid')">
                      {{ getValueForMonth(month, "landlord_edited_paid") | formatMoney }}
                    </div>
                  </td>
                  <td class="uk-text-right">
                    <div v-if="getValueForMonth(month, 'landlord_edited_fees') != getValueForMonth(month, 'fees')">
                      {{ getValueForMonth(month, "landlord_edited_fees") | formatMoney }}
                    </div>
                  </td>
                  <td class="uk-text-right" v-if="showAlternativeFunding">
                    <div
                      v-if="checkedMonths.includes(month.format(monthFormat)) && monthInputs[month.format(monthFormat)]"
                    >
                      <div class="uk-margin-bottom">
                        <div v-for="(program, i) in getLLAlternative(month)" :key="i">
                          {{ program.pivot.amount | formatMoney }} -
                          {{ getAlernativeFundProgramName(program.pivot.alternative_funding_program_id) }}
                        </div>
                      </div>
                    </div>
                  </td>
                  <td class="uk-text-right"></td>
                  <td class="uk-text-right"></td>
                </tr>
                <tr v-if="isLastEligibleMonth(month) && userCanViewEligibilityMonth" class="eligibility-divider">
                  <td colspan="7"></td>
                </tr>
              </template>
            </tbody>
          </table>

          <p v-if="futureMonths() > 1 && programSettings['show-additional-month-reminder'] && env.LANG_KEY !== 'clackamas_'">
            {{
              __("tenant.additional_months_reminder", {
                future_months: futureMonths(),
                type: getAssistanceLabel(type),
              })
            }}
          </p>
        </div>
        <div
          class="uk-grid uk-width-small-1-1 uk-hidden-medium uk-hidden-large uk-form uk-form-horizontal uk-form-stacked"
        >
          <div class="uk-width-1-1 uk-grid" v-for="(month, key) in months" :key="`mobile-${key}`" :class="getClassForMonth(month)">
            <div class="uk-width-1-1">
              <h4>
                <input
                  v-if="getValueForMonth(month, 'own_ule') || !monthInputs[month.format(monthFormat)]"
                  type="checkbox"
                  :value="month.format(monthFormat)"
                  :disabled="getValueForMonth(month, 'has_payment') !== 0"
                  @change="onMonthCheckedChange(month, $event)"
                  v-model="checkedMonths"
                />
                <a
                  v-else-if="
                    permissions.processor &&
                    !getValueForMonth(month, 'own_ule') &&
                    !getValueForMonth(month, 'has_payment') &&
                    monthInputs[month.format(monthFormat)]
                  "
                  href="javascript:;"
                  @click="transferRecord(month)"
                >
                  <i class="uk-icon-forward use-hand-cursor" uk-tooltip title="Transfer this record"></i>
                </a>
                <a v-if="monthInputs[month.format(monthFormat)]" href="javascript:;">
                  <i class="uk-icon-info" uk-tooltip :title="getTooltipForMonth(month)"></i>
                </a>
                {{ month.format("MMM YYYY") }}
              </h4>
            </div>
            <div
              class="uk-width-1-1 uk-margin-top uk-margin-large-bottom"
              v-if="checkedMonths.includes(month.format(monthFormat))"
            >
              <div class="uk-form-row">
                <label class="uk-form-label" for="">
                  {{ month.format("MMMM") }} {{ getAssistanceLabel(type) }} {{ programSettings["ledger-title-amount-due"] }}
                </label>
                <div class="uk-form-controls">
                  <div
                    v-if="
                      getValueForMonth(month, 'own_ule') &&
                      checkedMonths.includes(month.format(monthFormat)) &&
                      monthInputs[month.format(monthFormat)] &&
                      !getValueForMonth(month, 'has_payment') &&
                      canEditLedgerAmounts
                    "
                  >
                    <template v-if="canChangeAmount">
                      <input
                        v-if="usingScreenReader"
                        :value="getValueForMonth(month, 'amount')"
                        @change="updateValueForMonth(month, 'amount', $event.target.value)"
                      />
                      <currency-input
                        v-else
                        :currency="{ prefix: '$ ' }"
                        :value="getValueForMonth(month, 'amount')"
                        @change="updateValueForMonth(month, 'amount', $event)"
                        class="small-input"
                      />
                    </template>
                    <span v-else class="uk-text-right">{{ getValueForMonth(month, "amount") | formatMoney }}</span>
                  </div>
                  <div
                    v-else-if="
                      checkedMonths.includes(month.format(monthFormat)) && monthInputs[month.format(monthFormat)]
                    "
                  >
                    {{ getValueForMonth(month, "amount") | formatMoney }}
                  </div>
                  <span v-else>-</span>
                </div>
              </div>
              <div class="uk-form-row">
                <label class="uk-form-label" for="">
                  {{ month.format("MMMM") }} {{ getAssistanceLabel(type) }} {{ programSettings["ledger-title-amount-paid"] }}
                </label>
                <div class="uk-form-controls">
                  <div
                    v-if="
                      getValueForMonth(month, 'own_ule') &&
                      checkedMonths.includes(month.format(monthFormat)) &&
                      monthInputs[month.format(monthFormat)] &&
                      !getValueForMonth(month, 'has_payment') &&
                      canEditLedgerAmounts
                    "
                  >
                    <template v-if="canChangeAmount">
                      <input
                        v-if="usingScreenReader"
                        :currency="{ prefix: '$ ' }"
                        :value="getValueForMonth(month, 'paid')"
                        @change="updateValueForMonth(month, 'paid', $event.target.value)"
                      />
                      <currency-input
                        v-else
                        :currency="{ prefix: '$ ' }"
                        :value="getValueForMonth(month, 'paid')"
                        @change="updateValueForMonth(month, 'paid', $event)"
                        class="small-input"
                      />
                    </template>
                    <span v-else class="uk-text-right">{{ getValueForMonth(month, "paid") | formatMoney }}</span>
                  </div>
                  <div
                    v-else-if="
                      checkedMonths.includes(month.format(monthFormat)) && monthInputs[month.format(monthFormat)]
                    "
                  >
                    {{ getValueForMonth(month, "paid") | formatMoney }}
                  </div>
                  <span v-else>-</span>
                </div>
              </div>
              <div class="uk-form-row" v-if="program.settings['uses-ledger-entry-fees']">
                <label class="uk-form-label" for="">
                  {{ month.format("MMMM") }} {{ getAssistanceLabel(type) }}
                  {{ programSettings["ledger-title-amount-fees-due"] }}
                  <span v-if="type.pivot.max_fee_amount" class="uk-text-muted">
                    (Max {{ type.pivot.max_fee_amount | formatMoney }})
                  </span>
                </label>
                <div class="uk-form-controls">
                  <div
                    v-if="
                      getValueForMonth(month, 'own_ule') &&
                      checkedMonths.includes(month.format(monthFormat)) &&
                      monthInputs[month.format(monthFormat)] &&
                      !getValueForMonth(month, 'has_payment') &&
                      canEditLedgerAmounts
                    "
                  >
                    <template v-if="canChangeAmount">
                      <input
                        v-if="usingScreenReader"
                        :value="getValueForMonth(month, 'fees')"
                        @change="updateValueForMonth(month, 'fees', $event.target.value)"
                      />
                      <currency-input
                        v-else
                        :currency="{ prefix: '$ ' }"
                        :value="getValueForMonth(month, 'fees')"
                        @change="updateValueForMonth(month, 'fees', $event)"
                        class="small-input"
                      />
                    </template>
                    <span v-else class="uk-text-right">{{ getValueForMonth(month, "fees") | formatMoney }}</span>
                  </div>
                  <div
                    v-else-if="
                      checkedMonths.includes(month.format(monthFormat)) && monthInputs[month.format(monthFormat)]
                    "
                  >
                    {{ getValueForMonth(month, "fees") | formatMoney }}
                  </div>
                  <span v-else>-</span>
                </div>
              </div>
              <div class="uk-form-row" v-if="showAlternativeFunding">
                <div
                  v-if="
                    getValueForMonth(month, 'own_ule') &&
                    checkedMonths.includes(month.format(monthFormat)) &&
                    monthInputs[month.format(monthFormat)]
                  "
                >
                  <div
                    class="uk-margin-bottom"
                    v-for="(program, i) in getArrayValueForMonth(month, 'alternative_funding_programs')"
                    :key="`mobile_alternative_funding_programs_${i}`"
                  >
                    <input v-if="usingScreenReader" v-model="program.pivot.amount" />
                    <currency-input v-else v-model="program.pivot.amount" :currency="{ prefix: '$ ' }" class="small-input"/>
                    <validated-section :errors="errors" :field="`month_${key}_program_${id}_alternative_fund`">
                      <select
                        placeholder="Select Source"
                        v-model="program.pivot.alternative_funding_program_id"
                        class="uk-input uk-select"
                        style="width: 175px"
                      >
                        <option :value="null">Choose a Source...</option>
                        <option v-for="_program in alternativeFundingPrograms" :value="_program.id">
                          {{ _program.name }}
                        </option>
                      </select>
                    </validated-section>
                    <a
                      href="javascript:;"
                      class="uk-text-danger"
                      v-if="canEditLedgerAmounts"
                      @click="monthInputs[month.format(monthFormat)].alternative_funding_programs.splice(i, 1)"
                    >
                      <i class="a-trash-2"></i>
                    </a>
                  </div>
                  <a
                    href="javascript:;"
                    v-if="canEditLedgerAmounts"
                    @click="addAssistance(monthInputs[month.format(monthFormat)].alternative_funding_programs)"
                  >
                    <i class="a-circle-plus"></i> {{ __("tenant.report_other_funding") }}
                  </a>
                </div>
                <span v-else>-</span>
              </div>
              <div class="uk-form-row">
                <label class="uk-form-label" for="">
                  {{ month.format("MMMM") }} {{ programSettings["ledger-title-amount-total-requested"] }}
                </label>
                <div class="uk-form-controls">
                  <div v-if="checkedMonths.includes(month.format(monthFormat))" class="uk-text-left">
                    {{ getRequestedAssistanceForMonth(month) | formatMoney }}
                  </div>
                  <span v-else>-</span>
                </div>
              </div>
              <template v-if="permissions.processor || (permissions.household && program.settings['show-paid-column'])">
                <div v-if="permissions.processor" class="uk-form-row">
                  <label class="uk-form-label" for="">{{ month.format("MMMM") }} {{ __("tenant.approved") }}</label>
                  <div class="uk-form-controls">
                    <span
                      v-if="checkedMonths.includes(month.format(monthFormat)) && monthInputs[month.format(monthFormat)]"
                    >
                      <span v-if="getValueForMonth(month, 'own_ule') && !getValueForMonth(month, 'has_payment')">
                        <input
                          v-if="usingScreenReader"
                          :value="getValueForMonth(month, 'approved')"
                          @change="updateValueForMonth(month, 'approved', $event.target.value)"
                        />
                        <currency-input
                          v-else
                          :currency="{ prefix: '$ ' }"
                          :value="getValueForMonth(month, 'approved')"
                          @change="updateValueForMonth(month, 'approved', $event)"
                          class="small-input"
                        />
                      </span>
                      <span v-else>
                        {{ getValueForMonth(month, "approved") | formatMoney }}
                      </span>
                    </span>
                    <span v-else>-</span>
                  </div>
                </div>
                <div class="uk-form-row">
                  <label class="uk-form-label" for="">{{ month.format("MMMM") }} {{ __("tenant.paid") }}</label>
                  <div class="uk-form-controls">
                    <span
                      v-if="checkedMonths.includes(month.format(monthFormat)) && monthInputs[month.format(monthFormat)]"
                    >
                      {{ getValueForMonth(month, "paid_by_sponsor") | formatMoney }}
                    </span>
                    <span v-else>-</span>
                  </div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </div>
      <div class="uk-width-1-1 uk-margin-top" v-if="type.pivot.type === 2 && needsAssistance">
        <div v-if="type.pivot.flat_rate_disclaimer" class="uk-alert" style="padding: 16px">
          {{ type.pivot.flat_rate_disclaimer }}
        </div>

        <div v-if="permissions.processor" class="uk-overflow-container uk-hidden-small uk-grid-width-medium-1-1">
          <table class="uk-table uk-table-divider uk-table-striped">
            <thead>
              <tr>
                <th>App #</th>
                <th>Request Amount</th>
                <th>Paid Amount</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(monthItem, month) in monthInputs">
                <tr :class="getClassForMonth(month)" :key="month">
                  <td>
                    <input
                      v-if="getValueForMonth(month, 'own_ule') || !monthItem"
                      v-model="checkedMonths"
                      type="checkbox"
                      :aria-label="month"
                      :disabled="getValueForMonth(month, 'has_payment') !== 0"
                      :value="month"
                      @change="onMonthCheckedChange(month, $event)"
                    />
                    <a
                      v-else-if="
                        permissions.processor &&
                        !getValueForMonth(month, 'own_ule') &&
                        !getValueForMonth(month, 'has_payment')
                      "
                      href="javascript:;"
                      @click="transferRecord(month)"
                    >
                      <i class="uk-icon-forward use-hand-cursor" uk-tooltip title="Transfer this record"></i>
                    </a>

                    <a
                      v-if="monthItem"
                      href="javascript:;"
                      :aria-label="getTooltipForMonth(month)"
                    >
                      <i class="uk-icon-info" uk-tooltip :title="getTooltipForMonth(month)"></i>
                    </a>
                    {{ getValueForMonth(month, 'application_id') }}
                  </td>
                  <td>
                    <div
                      v-if="
                        getValueForMonth(month, 'own_ule') &&
                        !getValueForMonth(month, 'has_payment') &&
                        canEditLedgerAmounts
                      "
                    >
                      <input
                        v-if="usingScreenReader"
                        :value="getValueForMonth(month, 'amount')"
                        @change="updateValueForMonth(month, 'amount', $event.target.value)"
                      />
                      <currency-input
                        v-else
                        :currency="{ prefix: '$ ' }"
                        :value="getValueForMonth(month, 'amount')"
                        @change="updateValueForMonth(month, 'amount', $event)"
                        class="small-input"
                      />
                    </div>
                    <div v-else>
                      {{ getValueForMonth(month, 'amount') | formatMoney }}
                    </div>
                  </td>
                  <td>
                    <div>
                      {{ getValueForMonth(month, "paid_by_sponsor") | formatMoney }}
                    </div>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
          <a class="uk-link" href="javascript:;" @click="onAddLedgerEntry"><i class="fa fa-plus"></i> Add ledger entry for this application</a>
        </div>

        <div v-else>
          <div class="uk-alert uk-alert-primary" >
            The maximum benefit for this assistance type is ${{ programFlatFeeLimit }}.
          </div>
          <div class="uk-alert uk-alert-warning">
            Note: <span v-if="flatFeeIsFromPreviousApplication">{{ getAssistanceLabel(type) }} was requested on a previously paid application for ${{ Math.max(this.totalSharedAmount, this.totalSharedPaid) }}. </span>This application is potentially eligible for ${{ flatFeeAvailable + totalOwnAmount }} which will be requested for this application.
          </div>
        </div>

        <div class="uk-margin-large-top">
          <validated-section :errors="errors" field="total_request">
          <h3 class="uk-text-bold">
            Total {{ getAssistanceLabel(type) }} Assistance Available: {{ permissions.processor ? programFlatFeeLimit : flatFeeAvailable + totalOwnAmount | formatMoney }}
          </h3>
          </validated-section>
        </div>
      </div>
      <div class="uk-width-1-1 uk-margin-top" v-else-if="type.pivot.type === 3 && needsAssistance">
        <div class="uk-overflow-container uk-hidden-small uk-grid-width-medium-1-1">
          <table class="uk-table uk-table-divider uk-table-striped">
            <thead>
              <tr>
                <th>Month<span v-if="futureMonths() > 1">*</span></th>
                <th>Monthly Flat Rate</th>
                <th class="uk-text-right">Total Requested</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="month in months">
                <td>
                  <input
                    type="checkbox"
                    :value="month.format(monthFormat)"
                    @change="onMonthCheckedChange(month, $event)"
                    v-model="checkedMonths"
                  />
                  {{ month.format("MMM YYYY") }}
                </td>
                <td>
                  <div
                    v-if="checkedMonths.includes(month.format(monthFormat)) && monthInputs[month.format(monthFormat)]"
                  >
                    <input
                      v-if="usingScreenReader"
                      :value="getValueForMonth(month, 'amount')"
                      @change="updateValueForMonth(month, 'amount', $event.target.value)"
                    />
                    <currency-input
                      v-else
                      :currency="{ prefix: '$ ' }"
                      :value="getValueForMonth(month, 'amount')"
                      @change="updateValueForMonth(month, 'amount', $event)"
                      class="small-input"
                    />
                  </div>
                  <span v-else>-</span>
                </td>
                <td class="uk-text-right">
                  <div v-if="checkedMonths.includes(month.format(monthFormat))" class="uk-text-right">
                    {{ getRequestedAssistanceForMonth(month) | formatMoney }}
                  </div>
                  <span v-else>-</span>
                </td>
              </tr>
            </tbody>
          </table>

          <p v-if="futureMonths() > 1 && programSettings['show-additional-month-reminder'] && env.LANG_KEY !== 'clackamas_'">
            {{
              __("tenant.additional_months_reminder", {
                future_months: futureMonths(),
                type: getAssistanceLabel(type),
              })
            }}
          </p>
        </div>
        <div
          class="uk-grid uk-width-small-1-1 uk-hidden-medium uk-hidden-large uk-form uk-form-horizontal uk-form-stacked"
        >
          <div class="uk-width-1-1 uk-grid" v-for="month in months">
            <div class="uk-width-1-1">
              <h4>
                <input type="checkbox" :value="month.format(monthFormat)" v-model="checkedMonths" />
                {{ month.format("MMM YYYY") }}
              </h4>
            </div>
            <div
              class="uk-width-1-1 uk-margin-top uk-margin-large-bottom"
              v-if="checkedMonths.includes(month.format(monthFormat))"
            >
              <div class="uk-form-row">
                <label class="uk-form-label" for=""
                  >{{ month.format("MMMM") }} {{ getAssistanceLabel(type) }} {{ programSettings["ledger-title-amount-due"] }}</label
                >
                <div class="uk-form-controls">
                  <input
                    v-if="usingScreenReader"
                    :value="getValueForMonth(month, 'amount')"
                    @change="updateValueForMonth(month, 'amount', $event.target.value)"
                  />
                  <currency-input
                    v-else
                    :currency="{ prefix: '$ ' }"
                    :value="getValueForMonth(month, 'amount')"
                    @change="updateValueForMonth(month, 'amount', $event)"
                    class="small-input"
                  />
                </div>
              </div>
              <div class="uk-form-row">
                <label class="uk-form-label" for=""
                  >{{ month.format("MMMM") }} {{ getAssistanceLabel(type) }} {{ programSettings["ledger-title-amount-paid"] }}</label
                >
                <div class="uk-form-controls">
                  <input
                    v-if="usingScreenReader"
                    :value="getValueForMonth(month, 'paid')"
                    @change="updateValueForMonth(month, 'paid', $event.target.value)"
                  />
                  <currency-input
                    v-else
                    :currency="{ prefix: '$ ' }"
                    :value="getValueForMonth(month, 'paid')"
                    @change="updateValueForMonth(month, 'paid', $event)"
                    class="small-input"
                  />
                </div>
              </div>
              <div class="uk-form-row" v-if="program.settings['uses-ledger-entry-fees']">
                <label class="uk-form-label" for="">
                  {{ month.format("MMMM") }} {{ getAssistanceLabel(type) }}
                  {{ programSettings["ledger-title-fees-due"] }}
                  <span v-if="type.pivot.max_fee_amount" class="uk-text-muted">
                    (Max {{ type.pivot.max_fee_amount | formatMoney }})
                  </span>
                </label>
                <div class="uk-form-controls">
                  <input
                    v-if="usingScreenReader"
                    :value="getValueForMonth(month, 'fees')"
                    @change="updateValueForMonth(month, 'fees', $event.target.value)"
                  />
                  <currency-input
                    v-else
                    :currency="{ prefix: '$ ' }"
                    :value="getValueForMonth(month, 'fees')"
                    @change="updateValueForMonth(month, 'fees', $event)"
                    class="small-input"
                  />
                </div>
              </div>
              <div
                class="uk-form-row"
                v-if="application.receiving_other_assistance && programSettings['uses-duplicative-assistance']"
              >
                <div v-if="checkedMonths.includes(month.format(monthFormat)) && monthInputs[month.format(monthFormat)]">
                  <label class="uk-form-label" for=""
                    >{{ month.format("MMMM") }} {{ getAssistanceLabel(type) }} {{ __("tenant.other_assistance_received") }}</label
                  >
                  <div
                    class="uk-margin-bottom"
                    v-for="(program, i) in monthInputs[month.format(monthFormat)].alternative_funding_programs"
                    :key="i"
                  >
                    <input v-if="usingScreenReader" v-model="program.pivot.amount" />
                    <currency-input v-else v-model="program.pivot.amount" :currency="{ prefix: '$ ' }" class="small-input" />
                    <select
                      aria-label="Select Source"
                      placeholder="Select Source"
                      v-model="program.pivot.alternative_funding_program_id"
                      class="uk-input uk-select"
                      style="width: 175px"
                    >
                      <option :value="null">Choose a Source...</option>
                      <option v-for="_program in alternativeFundingPrograms" :value="_program.id" :key="_program.id">
                        {{ _program.name }}
                      </option>
                    </select>
                    <a
                      href="javascript:;"
                      class="uk-text-danger"
                      @click="monthInputs[month.format(monthFormat)].alternative_funding_programs.splice(i, 1)"
                      ><i class="a-trash-2"></i
                    ></a>
                  </div>
                  <a
                    href="javascript:;"
                    @click="addAssistance(monthInputs[month.format(monthFormat)].alternative_funding_programs)"
                    ><i class="a-circle-plus"></i> {{ __("tenant.report_other_funding") }}</a
                  >
                </div>
              </div>
              <div class="uk-form-row">
                <label class="uk-form-label" for=""
                  >{{ month.format("MMMM") }} {{ programSettings["ledger-title-amount-due"] }}</label
                >
                <div class="uk-form-controls">
                  <strong>{{ getRequestedAssistanceForMonth(month) | formatMoney }}</strong>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="uk-width-1-1 uk-margin-top" v-else>
        <validated-section :errors="errors" field="total_request">
          <h3
            class="uk-text-bold"
            :aria-label="__('tenant.total_assistance_requested_type', {type: getAssistanceLabel(type)}) + `$${totalRequested}`"
            tabindex="0"
          >
            {{ __('tenant.total_assistance_requested_type' , {type: getAssistanceLabel(type)}) }}:
            {{ totalRequested | formatMoney }}
          </h3>
          <template v-if="permissions.processor">
            <h3 class="uk-text-bold">
              {{ __('tenant.total_assistance_approved_type' , {type: getAssistanceLabel(type)}) }}:
              {{ totalApproved | formatMoney }}
            </h3>
            <h3 class="uk-text-bold">
              {{ __('tenant.total_assistance_paid_type' , {type: getAssistanceLabel(type)}) }}:
              {{ totalProgramPaid | formatMoney }}
            </h3>

          </template>
        </validated-section>

        <div class="uk-width-1-1" style="padding-top: 12px;" v-if="userCanViewEligibilityMonth">
          Months that are below the dashed line are beyond the last eligible month for funding under
          this program, and should be transferred to a new application.
        </div>
      </div>
    </div>

    <unit-ledger-entry-history-modal
      v-if="permissions.processor"
      @onRestoreUle="onRestoreUle"
      :type="type"
      ref="historyModal"
    ></unit-ledger-entry-history-modal>
    <modal-dialog
      title="Transfer Confirmation"
      ref="confirmTransfer"
      @confirm="onCompleteModalConfirmTransfer"
      confirmText="Transfer"
      :stuck="true"
    >
      Are you sure you want to transfer this entry to the current application?
    </modal-dialog>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import moment from "moment";
import ValidatedSection from "../../Common/ValidatedSection";
import Autocomplete from "@trevoreyre/autocomplete-vue";
import UnitLedgerEntryHistoryModal from "../../../../components/UnitLedgerEntryHistoryModal";
import ModalDialog from "../../Common/ModalDialog";
import accounting from "accounting";

const TYPE_LEDGER = 1;
const TYPE_FLAT_FEE_ONE_TIME = 2;
const TYPE_FLAT_FEE_PER_MONTH = 3;
const TYPE_LEDGER_NO_DISCONNECT = 4;
const TYPE_LEDGER_SIMPLIFIED = 5;

export default {
  name: "LedgerEntriesForType",
  components: {
    UnitLedgerEntryHistoryModal,
    ValidatedSection,
    Autocomplete,
    ModalDialog,
  },
  props: {
    type: {
      type: Object,
      required: true,
    },
    entries: {
      type: Array,
      default() {
        return [];
      },
    },
    showDisconnect: {
      type: Boolean,
      default: true,
    },
    formErrors: {
      required: true,
    }
  },
  data() {
    return {
      errors: {},
      needsAssistance: false,
      checkedMonths: [],
      monthInputs: {},
      now: moment(),
      monthFormat: "YYYY-MM",
      hhMemberId: null,
      disconnectStatusId: null,
      vendorId: null,
      vendor: null,
      accountNumber: null,
      accountNumberConfirmation: null,
      vendors: [],
      paymentAgreement: 0,

      // Consts
      TYPE_LEDGER,
      TYPE_FLAT_FEE_ONE_TIME,
      TYPE_FLAT_FEE_PER_MONTH,
      TYPE_LEDGER_NO_DISCONNECT,
      TYPE_LEDGER_SIMPLIFIED,
    };
  },
  computed: {
    showPaid() {
      return this.program.settings['show-paid-column']
    },
    showApproved() {
      return this.permissions.processor
    },
    lastMonth() {
      const keys = Object.keys(this.monthInputs);
      if (keys && keys.length)
      {
        return moment(keys[keys.length-1]).startOf('month')
      }
      return null
    },
    disableAssistanceCheckbox()
    {
      return this.isLocked
    },

    isHomeless() {
      return this.application.is_homeless && this.programSettings['uses-homeless-application']
    },

    batches() {
      let batches = [];
      _.each(this.entries, (item) => {
        if (item.batch_vendor_payment && !batches.includes(item.batch_vendor_payment.batch_payment_id)) {
          batches.push(item.batch_vendor_payment.batch_payment_id);
        }
      });
      return batches;
    },

    isLocked() {
      return this.hasBatchPayment
    },

    hasBatchPayment() {
      let result = false;
      _.each(this.monthInputs, input => {
        if(input.own_ule && input.has_payment) {
          result = true;
        }
      })
      return result;
    },

    showAlternativeFunding() {
      return this.application.receiving_other_assistance && this.programSettings["uses-duplicative-assistance"];
    },
    isFlatFeeType() {
      return this.type.pivot.type === 2;
    },
    appIds() {
      const result = [...this.previousApps]
      result.push(this.application.id)
      return result
    },
    previousApps() {
      let result = [];
      _.each(this.monthInputs, (input) => {
        if (input.own_ule == false) {
          !result.includes(input.application_id) && result.push(input.application_id)
        }
      });
      return result
    },

    appProgramIds() {
      let programIds = [];
      _.each(this.monthInputs, (input) => {
        programIds.push(input.program_id)
      });
      return programIds
    },

    programFlatFeeLimit() {
      return this.type.pivot.flat_rate_amount
    },

    maxFlatFeeLimit() {
      let activePrograms = this.programs.filter(item => item.unit_ledger_entry_type_id == this.type.id)
      return _.max(_.map(activePrograms, programItem => programItem.flat_rate_amount));
    },

    flatFeeIsFromPreviousApplication() {
      let isFromPrevious = false;
      _.each(this.monthInputs, (input) => {
        if (input.own_ule == false) {
          isFromPrevious = true;
        }
      });
      return this.isFlatFeeType && isFromPrevious;
    },

    programLimitValid() {
      return this.programFlatFeeLimit && this.programFlatFeeLimit >= this.flatFeeTotalPotentialAmount
    },

    globalLimitValid() {
      return this.maxFlatFeeLimit && this.maxFlatFeeLimit >= this.flatFeeTotalPotentialAmount
    },

    flatFeeLimitValid() {
      return this.programLimitValid && this.globalLimitValid
    },

    flatFeeTotalPotentialAmount() {
      return _.sum(_.map(this.monthInputs, item => Math.max(item.amount, item.paid_by_sponsor)))
    },

    flatFeeAvailable() {
      let programAmount = this.programLimitValid ? this.programFlatFeeLimit - this.flatFeeTotalPotentialAmount : 0;
      let globalAmount = this.globalLimitValid ? this.maxFlatFeeLimit - this.flatFeeTotalPotentialAmount : 0

      return Math.min(programAmount, globalAmount);
    },

    hasFlatFeeAvailable() {
      return this.flatFeeAvailable > 0
    },
    hasOwnUle() {
      let result = false
      _.each(this.monthInputs, input => {
        if(input.own_ule) {
          result = true;
        }
      })
      return result
    },
    flatFeeUleItems() {
      if (!this.isFlatFeeType) return null;
      return _.filter(this.monthInputs, (input) => {
        return input.own_ule == true && input.ledger_entry_id;
      });
    },
    canChangeAmount() {
      let canChange = false;
      let allowed = this.program.settings["user-roles-to-edit-assistance-values"];
      if (this.user !== null && this.user !== undefined) {
        for (let j in this.user.roles) {
          let role = this.user.roles[j];
          for (var i in allowed) {
            let allowedRoleId = parseInt(allowed[i]);
            if (role.role_id === allowedRoleId) {
              canChange = true;
            }
          }

          if (role.role_id === 6) {
            canChange = true;
          }
        }
      }

      return canChange;
    },
    canEditLedgerAmounts() {
      return this.canChangeAmount;
    },
    canShowLedger() {
      if (this.type.id === 1) {
        return this.application.ami_subsidy_adjusted !== 0 || this.programSettings["ami-blocks-rent-entries"] === false;
      }
      return this.type.pivot.type === 1 || this.type.pivot.type === 3 || this.type.pivot.type === 4 || this.type.pivot.type === 5;
    },
    months() {
      let months = [];
      if (this.program)
      {
        let start = moment(this.program.assistance_start).startOf('month');
        if (this.isHomeless && this.programSettings['allow-only-futuer-month-rent-assistance'] && this.type.key === "rent")
        {
          start = moment(new Date()).startOf('month');
        }
        let end = moment(this.program.assistance_end);
        if (this.lastMonthEntries && this.lastMonthEntries > this.program.assistance_end)
        {
          end = moment(this.lastMonthEntries);
        }
        let added = parseInt(this.programSettings["ledger-entry-future-months"]);
        if (this.type.pivot.additional_months) {
          added = parseInt(this.type.pivot.additional_months);
        }
        if(this.type.pivot.future_months_only) {
          start = moment().add(1, 'month').startOf('month');
        }
        let endToShow = this.now.clone().add(added, "months");
        if (start.isValid() && end.isValid())
        {
          while (start.isBefore(end)) {
            if (start.isAfter(endToShow)) break;
            if (start.isAfter(end)) break;

            months.push(start.clone());

            start.add(1, "month");
          }
        }
      }

      return months;
    },
    totalRequested() {
      let total = 0;
      _.each(this.months, (month) => {
        let monthInput = this.monthInputs[month.format(this.monthFormat)];
        if (monthInput && monthInput.own_ule) {
          total += this.getRequestedAssistanceForMonth(month);
        }
      });
      return total;
    },
    totalProgramAmount() {
      return this.getTotalAmount('program')
    },
    totalSharedAmount() {
      return this.getTotalAmount('shared')
    },
    totalGlobalAmount() {
      return this.getTotalAmount()
    },

    totalProgramPaid() {
      return this.getTotalPaid('program');
    },

    totalSharedPaid() {
      return this.getTotalPaid('shared');
    },

    totalGlobalPaid() {
      return this.getTotalPaid();
    },

    totalOwnAmount() {
      let total = 0;
      _.each(this.months, (month) => {
        let monthInput = this.monthInputs[month.format(this.monthFormat)];
        if (monthInput && monthInput.own_ule) {
          total += monthInput.amount
        }
      });
      return total;
    },
    totalApproved() {
      let total = 0;
      _.each(this.months, (month) => {
        let monthInput = this.monthInputs[month.format(this.monthFormat)];
        if (monthInput && monthInput.own_ule) {
          total += this.getValueForMonth(month, "approved");
        }
      });
      return total;
    },
    entries() {
      const allUnitLedgerEntries = this.unitLedgerEntries.concat(this.sharedUnitLedgerEntries);
      return _.sortBy(_.filter(allUnitLedgerEntries, (entry) => entry.unit_ledger_entry_type_id === this.type.id), item => item.pivot && item.pivot.household_application_id == this.application.id ? 1 : 0 )
    },
    lastMonthEntries() {
      let item = _.last(_.sortBy(this.entries, 'date'))
      if (item)
        return item.date + '-15'
      return undefined
    },
    userCanViewEligibilityMonth() {
      let canView = false;
      _.each(this.program.settings['user-roles-to-see-eligible-months-limit'], roleId => {
        _.each(this.user.roles, role => {
          if(role.role_id == roleId) {
            canView = true;
          }
        });
      });
      return canView;
    },
    ...mapState("App", ["permissions", "user", "usingScreenReader", "env"]),
    ...mapState("Application", {
      assets: state => state.assets,
      unitLedgerEntries: state => state.application && state.application.unit_ledger_entries ? state.application.unit_ledger_entries : [],
      sharedUnitLedgerEntries: state => state.application && state.application.shared_unit_ledger_entries? state.application.shared_unit_ledger_entries : [],
      landlordConfirmations: state => state.landlordConfirmations,
      application: state => state.application,
      program: state => state.application.program,
      programs: state => state.application.programs,
      householdMembers: state => state.hhMembers,
      alternativeFundingPrograms: state => state.assets.alternativeFundingPrograms,
      monthInputsByType: state => state.monthInputsByType,
    }),
    ...mapGetters("Application", ["programSettings"]),
  },
  watch: {
    monthInputs: {
      deep: true,
      handler: function(newValue, oldValue) {
        this.$store.commit('Application/setMonthInput', {
          type: this.type,
          monthInputs: newValue,
        })
      }
    },
    'entries': {
      handler: function(newValue, oldValue) {
        if (newValue && !_.isEqual(newValue, oldValue))
        {
          this.setDataFromEntries();
        }
      },
      deep: true,
    },
    isLocked(newValue, oldValue) {
      if (newValue !== oldValue)
      {
        this.$emit('isLocked', newValue)
      }
    }
  },
  async mounted() {
    if (this.entries) {
      this.setDataFromEntries();
    }
  },
  methods: {
    isEmptyObject(obj) {
      return _.isEmpty(obj);
    },
    onNeedAssistanceChange() {
      if (this.needsAssistance) {

        if (this.type.pivot.type === 2 && this.hasFlatFeeAvailable && !this.permissions.processor) {
          let exitingMonth = undefined
          if (this.flatFeeUleItems)
          {
            _.each(this.months, (month) => {
              let monthInput = this.monthInputs[month.format(this.monthFormat)];
              if (monthInput && monthInput.own_ule && !monthInput.batch_payment_id) {
                exitingMonth = month
              }
              return false
            });
          }
          if (exitingMonth) {
            this.monthInputs[exitingMonth.format(this.monthFormat)]['amount'] += this.flatFeeAvailable
          } else {
            this.onAddLedgerEntry()
          }
        }
      }
      this.$emit("updated", this.monthInputs);
    },

    addUnitLedgerEntry(month) {
      let amount = 0;
      if (this.type.pivot.type === 3) {
        amount = parseFloat(this.programFlatFeeLimit);
      } else if (this.type.pivot.type == 2) {
        amount = this.flatFeeAvailable
      }

      if (this.type.pivot.type == 2 && amount == 0 && this.permissions.processor)
      {
        Vue.$toast.error("Sorry, You already have requested max amount available.", {
          position: "top-right",
        });
        return false
      }

      if (this.monthInputs[month] === undefined) {
        this.$set(this.monthInputs, month, {
          amount: amount,
          fees: 0,
          paid: 0,
          approved: 0,
          paid_by_sponsor: 0,
          other_funding_amount:0,
          other_funding_source_id:0,
          alternative_funding_programs: [],
          has_payment: false,
          own_ule: true,
          landlord_edited_alternative_funding_programs: [],
          organization_id: this.vendorId,
          organization_name: this.vendor ? this.vendor.organization_name : "",
          application_id: this.application.id,
          unit_ledger_entry_type_id: this.type.id,
          program_id: this.application.program_id,
        });
      }
      return true;
    },

    onAddLedgerEntry() {
      let availableMonth = '2020-04';

      _.each(this.checkedMonths, (month) => {
        if (month >= availableMonth)
        {
          availableMonth = moment(month).add(1, "month").format(this.monthFormat)
        }
      });

      let res = this.addUnitLedgerEntry(availableMonth);
      if (res)
      {
        if (!this.checkedMonths.includes(availableMonth))
        {
          this.checkedMonths.push(availableMonth);
        }
        this.$emit("updated", this.monthInputs);
      }
    },

    onCompleteModalConfirmTransfer(data) {
      const { id, monthFormatted } = data;
      this.$isLoading(true)
      axios
        .post(`/api/hope/applications/${this.application.id}/transfer-ledger/${id}`)
        .then((res) => {
          this.$isLoading(false)
          if (this.monthInputs[monthFormatted] !== undefined) {
            this.monthInputs[monthFormatted]["own_ule"] = true;
          }
          Vue.$toast.success("Record has been transferred successfully.", {
            position: "top-right",
          });
        })
        .catch((error) => {
          this.$isLoading(false)
          Vue.$toast.error("Something went wrong, Please try again later.", {
            position: "top-right",
          });
        });
    },

    transferRecord(month) {
      let key = month
      if (typeof(month) == 'object') {
        key = month.format(this.monthFormat)
      }

      this.$refs.confirmTransfer.setData({
        monthFormatted: key,
        id: this.getValueForMonth(key, "ledger_entry_id"),
      });
      this.$refs.confirmTransfer.open();
    },
    getAlernativeFundProgramName(id) {
      const p = this.alternativeFundingPrograms.find((item) => item.id == id);
      return p ? p.name : "N/A";
    },
    getLLAlternative(month) {
      const LLAlternativeFundingProgram = this.getArrayValueForMonth(
        month,
        "landlord_edited_alternative_funding_programs"
      );
      return LLAlternativeFundingProgram;
    },
    isAlternativeEdited(month, i) {
      let show = false;
      const LLAlternativeFundingProgram = this.getArrayValueForMonth(
        month,
        "landlord_edited_alternative_funding_programs"
      );
      if (
        LLAlternativeFundingProgram.hasOwnProperty(i) &&
        LLAlternativeFundingProgram[i].pivot.amount !=
          this.getArrayValueForMonth(month, "alternative_funding_programs")[i].pivot.amount
      ) {
        show = true;
      }
      return show;
    },

    showLLEdit(month) {
      let show = false;
      let lastLandlordConfirmation = _.chain(this.landlordConfirmations)
        .filter(item => item.signed_at !== null)
        .sortBy('signed_at')
        .last()
        .value();

      let hasLLCorrected = lastLandlordConfirmation && lastLandlordConfirmation.approval === 'corrected';

      if (!this.type.is_utility && this.type.key === "rent" && hasLLCorrected && this.getValueForMonth(month, "own_ule")) {
        const
          amount = this.getValueForMonth(month, "amount"),
          paid = this.getValueForMonth(month, "paid"),
          fees = this.getValueForMonth(month, "fees"),
          alternativeFundingProgram = this.getArrayValueForMonth(month, "alternative_funding_programs"),
          LLAmount = this.getValueForMonth(month, "landlord_edited_amount"),
          LLPaid = this.getValueForMonth(month, "landlord_edited_paid"),
          LLFee = this.getValueForMonth(month, "landlord_edited_fees"),
          LLAlternativeFundingProgram = this.getArrayValueForMonth(
            month,
            "landlord_edited_alternative_funding_programs"
          );

        show =
          LLAmount != amount ||
          LLPaid != paid ||
          LLFee != fees;

        const count = Math.max(alternativeFundingProgram.length, LLAlternativeFundingProgram.length);
        for (var i = 0; i < count; i++) {
          if (LLAlternativeFundingProgram.hasOwnProperty(i)) {
            if (
              !alternativeFundingProgram.hasOwnProperty(i) ||
              LLAlternativeFundingProgram[i].pivot.amount != alternativeFundingProgram[i].pivot.amount
            ) {
              show = show || true;
            }
          }
        }
      }

      return show;
    },

    getTotalAmount(type = 'global') {
      let total = 0;
      _.each(this.monthInputs, (item) => {
        if (type === 'global' || (type ==='program' && item.own_ule) || (type === 'shared' && !item.own_ule))
        {
          total += item.amount
        }
      });
      return total;
    },

    getTotalPaid(type = 'global') {
      let total = 0;
      _.each(this.months, (month) => {
        let monthInput = this.monthInputs[month.format(this.monthFormat)];
        if (monthInput && (type === 'global' || (type ==='program' && monthInput.own_ule) || (type === 'shared' && !monthInput.own_ule))) {
          total += this.getValueForMonth(month, "paid_by_sponsor");
        }
      });
      return total;
    },
    getCheckboxText(type) {
      if (type.pivot && type.pivot.custom_checkbox_text) return type.pivot.custom_checkbox_text;
      return this.__("tenant.do_you_need_assistance_for_your") + " " + this.getAssistanceLabel(type) + "?";
    },
    getAssistanceLabel(type) {
      return type.pivot?.custom_label ?? type.name
    },

    setDefaultVendor(id) {
      axios.get(`/api/hope/vendor/${id}`).then((r) => {
        if (r.data) {
          this.vendor = r.data;
          this.vendorId = this.vendor.id;
          this.$nextTick(() => {
            if (this.$refs.autocomplete && this.vendor) {
              this.$refs.autocomplete.value = this.vendor.organization_name;
            }
          });
        }
      });
    },

    getClassForMonth(month) {
      let orgId = this.getValueForMonth(month, "organization_id"),
        batchOrgId = this.getValueForMonth(month, "vendor_organization_id"),
        hasPayment = this.getValueForMonth(month, "has_payment"),
        isPaid = this.getValueForMonth(month, "paid_by_sponsor");
      return {
        // Flash when the row has a payment but not paid by sponsor
        'attention': hasPayment && !isPaid,

        // Turn green if the row has a payment
        "light-green": hasPayment,

        // Turn red if the organization id for the row does not equal the selected vendor above.
        "light-red":
            (orgId && orgId !== this.vendorId) ||
            (
                batchOrgId
                && this.programSettings['use-ule-error-for-batch-vendor-mismatch']
                && batchOrgId !== orgId
            )
      };
    },

    getTooltipForMonth(month) {
      let appId = this.getValueForMonth(month, "application_id");
      let orgId = this.getValueForMonth(month, "organization_id");
      let vendor_id = this.getValueForMonth(month, "vendor_id");
      let program_name = this.getValueForMonth(month, "program");
      let vendorName = this.getValueForMonth(month, "organization_name");
      let batchId = this.getValueForMonth(month, "batch_payment_id");
      let batchPaid = this.getValueForMonth(month, "batch_payment_date");
      let batchTransaction = this.getValueForMonth(month, "batch_transaction_id");
      let batchCheck = this.getValueForMonth(month, "batch_check_number");
      let batchOrgId = this.getValueForMonth(month, "batch_org_id");
      let batchVendorId = this.getValueForMonth(month, "batch_vendor_id");
      let batchVendorName = this.getValueForMonth(month, "batch_vendor_name");

      let tooltip = `App #${appId}, ${program_name}<hr /> UVID: #${vendor_id} || UOID: #${orgId} <br />NAME: ${vendorName}`;
      if (batchId) {
        tooltip += `<hr /> Batch #${batchId} :  <br /> BVID: #${batchVendorId} | BOID: #${batchOrgId} <br />NAME: ${batchVendorName}`;
      }
      if (batchPaid) {
        tooltip += ` <hr /> Paid ` + moment(batchPaid).format("MM/DD/YYYY") + ` | TID: ${batchTransaction} | CHECK: ${batchCheck}`;
      }

      return tooltip;
    },

    async getVendors() {
      // let r = await axios.get(`/api/hope/vendors?entry_type_id=${this.type.id}`);
      // this.vendors = r.data;
    },
    async searchVendors(query) {
      if (query.length < 3) return [];
      let r = await axios.get(
        `/api/hope/vendors?application_id=${this.application.id}&entry_type_id=${this.type.id}&q=${query}&usecase=ledger_entry_vendor_search`
      );
      return r.data;
    },
    getResultValue(result) {
      return result.organization_name;
    },
    onRestoreUle({ vendor, ules }) {
      this.setVendor(vendor);
      if (ules && ules.length) {
        const entry = ules[0];
        if (entry.account_number) {
          this.accountNumber = entry.account_number;
          this.accountNumberConfirmation = entry.account_number;
        }
      }
    },

    setVendor(result) {
      this.vendors.push(result);
      this.vendor = result;
      this.vendorId = result.id;
      window.setTimeout(() => {
        if (this.$refs.autocomplete) {
          this.$refs.autocomplete.value = this.vendor.organization_name;
        }
      }, 1000);
    },
    async setVendorFromTextValue($event) {
      if ($event.target.value && !this.vendor) {
        UIkit.modal.confirm(
          `If you don't see your vendor/provider, please select "Other, Please See Bill".`,
          async () => {
            this.vendorId = null;
            this.$refs.autocomplete.value = "";
          },
          () => {
            this.vendorId = null;
            this.$refs.autocomplete.value = "";
          },
          {
            labels: {
              Ok: "Ok",
              Cancel: "Dismiss",
            },
          }
        );
      }
    },

    onMonthCheckedChange(month, $event) {
      let key = month
      if (typeof(month) == 'object') {
        key = month.format(this.monthFormat)
      }

      if ($event.target.checked === false) {
        this.$delete(this.monthInputs, key);
      } else {

        // Check to see if the program setting for max months is enabled, and make
        // sure the limit for maximum months is not being exceeded
        let monthsAllowedCountIndependent = this.type.pivot.max_months_allowed;
        let monthsAllowedType = this.programSettings['months-allowed-type'];
        let monthAllowedCount = this.programSettings['months-allowed-amount'];
        let monthsAllowedPrograms = this.programSettings['months-allowed-program-scope'];
        if (monthsAllowedCountIndependent > 0)
        {
          let currentMonthCount = Object.keys(this.monthInputs).length

          if (currentMonthCount >= monthsAllowedCountIndependent)
          {
            this.$nextTick(() => {
              this.$toast.error(`The ${this.getAssistanceLabel(type)} requested exceeds the allowable max number of months.`, {
                position: "top-right",
              });
              $(this.$refs['input_'+month]).prop('checked', false);
            })
          } else {
            this.addUnitLedgerEntry(key)
          }
        } else if(monthAllowedCount > 0) {
          // Get number of checked months
          let selectedMonths = [];


          _.each(this.monthInputsByType, (payload, typeId) => {
            let monthInputs = payload.data,
              assistanceType = payload.type
            if (assistanceType.pivot.type !== 2 && !this.type.pivot.max_months_allowed)
            {
              _.each(monthInputs, (monthInput, monthString) => {
                if(!monthsAllowedPrograms.includes(monthInput.program_id.toString())) {
                  return;
                }
                if(monthsAllowedType === 'cumulative') {
                  monthString = monthString + '_' + monthInput.unit_ledger_entry_type_id;
                }
                if(!selectedMonths.includes(monthString)) {
                  selectedMonths.push(monthString);
                }
              });
            }
          })


          if(selectedMonths.length < monthAllowedCount) {
            this.addUnitLedgerEntry(key)
          }else {
            this.$nextTick(() => {
              this.$toast.error("Sorry, You already have requested max number of months available.", {
                position: "top-right",
              });
              $(this.$refs['input_'+month]).prop('checked', false);
            })
          }
        }else {
          this.addUnitLedgerEntry(key)
        }

      }

      this.$emit("updated", this.monthInputs);
    },

    setDataFromEntries() {
      this.needsAssistance = false;
      this.monthInputs = {};
      this.checkedMonths = [];
      this.accountNumber = null;
      this.accountNumberConfirmation = null;

      const applyLL = this.type.key === "rent"

      _.each(this.entries, (entry) => {
        if (!this.needsAssistance) {
          if (this.type.pivot.type != 2 || this.type.pivot.type == 2 && entry.pivot.household_application_id == this.application.id) {
            this.needsAssistance = true;
          }
        }

        let formattedDate = moment(entry.due_date).format(this.monthFormat);

        let assistanceApprovedAmount;
        if (entry.pivot.assistance_amount_approved !== undefined) {
          assistanceApprovedAmount = parseFloat(entry.pivot.assistance_amount_approved);
        } else if (applyLL) {
          assistanceApprovedAmount =
            parseFloat(entry.ll_due) +
            parseFloat(entry.ll_fees) -
            parseFloat(entry.ll_paid);
          if (
            entry.ll_alternative_funding_programs &&
            entry.ll_alternative_funding_programs.length
          ) {
            _.each(entry.ll_alternative_funding_programs, (afp) => {
              assistanceApprovedAmount -= parseFloat(afp.pivot.amount);
            });
          }
        } else {
          assistanceApprovedAmount =
            parseFloat(entry.amount_due) + parseFloat(entry.fees_due) - parseFloat(entry.amount_paid);
          if (entry.alternative_funding_programs && entry.alternative_funding_programs.length) {
            _.each(entry.alternative_funding_programs, (afp) => {
              assistanceApprovedAmount -= parseFloat(afp.pivot.amount);
            });
          }
        }

        let own_ule = entry.pivot.household_application_id == this.application.id

        this.$set(this.monthInputs, formattedDate, {
          amount: entry.amount_due ? parseFloat(entry.amount_due) : 0,
          fees: entry.fees_due ? parseFloat(entry.fees_due) : 0,
          paid: entry.amount_paid ? parseFloat(entry.amount_paid) : 0,
          other_funding_amount: entry.other_funding_amount ? parseFloat(entry.other_funding_amount) : 0,
          other_funding_source_id: entry.other_funding_source_id ? parseInt(entry.other_funding_source_id) : 0,
          alternative_funding_programs: entry.alternative_funding_programs,
          approved: assistanceApprovedAmount,
          paid_by_sponsor: entry.batch_vendor_payment
            ? parseFloat(entry.batch_vendor_payment.amount_paid_by_sponsor)
            : 0,
          has_payment: entry.batch_vendor_payment ? true : false,
          landlord_edited_amount: applyLL ? entry.ll_due : null,
          landlord_edited_fees: applyLL ? entry.ll_fees : null,
          landlord_edited_paid: applyLL ? entry.ll_paid : null,
          landlord_edited_alternative_funding_programs: applyLL
            ? entry.ll_alternative_funding_programs
            : [],
          own_ule,
          batch_payment_id: entry.batch_vendor_payment ? entry.batch_vendor_payment.batch_payment_id : null,
          vendor_organization_id: entry.batch_vendor_payment ? entry.batch_vendor_payment.vendor_organization_id : null,
          batch_org_id: entry.batch_vendor_payment ? entry.batch_vendor_payment.vendor_organization_id : 'NO VENDOR ORG ID',
          batch_check_number: entry.batch_vendor_payment ? entry.batch_vendor_payment.check_number : 'NO CHECK',
          batch_transaction_id: entry.batch_vendor_payment ? entry.batch_vendor_payment.transaction_id : 'NO TRASACTION ID',
          batch_vendor_name: entry.batch_vendor_payment ? entry.batch_vendor_payment.organization_name : 'NO VENDOR NAME',
          batch_vendor_id: entry.batch_vendor_payment ? entry.batch_vendor_payment.vendor_id : 'NO VENDOR ID',
          batch_payment_date: entry.batch_vendor_payment ? entry.batch_vendor_payment.date_paid : null,
          application_id: entry.pivot ? entry.pivot.household_application_id : null,
          ledger_entry_id: entry.id,
          organization_id: entry.vendor_organization_id,
          vendor_id: entry.organization ? (entry.organization.vendor_id ? entry.organization.vendor_id : null) : null,
          organization_name: entry.organization ? entry.organization.organization_name : null,
          program: entry.program_name ? entry.program_name : 'NO PROGRAM THROUGH APPLICATION',
          program_key: entry.program_key ? entry.program_key : null,
          unit_ledger_entry_type_id: this.type.id,
          program_id: entry.program_application_unit_ledger_entry ? entry.program_application_unit_ledger_entry.household_application.program_id : null,
        });

        this.checkedMonths.push(formattedDate);

        if (own_ule)
        {
          this.hhMemberId = entry.household_member_id;
        } else {
          this.hhMemberId = entry.org_hh_member_id;
        }

        if ((!this.disconnectStatusId || own_ule) && entry.disconnect_status_id !== null) {
          this.disconnectStatusId = entry.disconnect_status_id;
        }

        if (entry.pivot.household_application_id == this.application.id)
        {
          this.paymentAgreement = entry.payment_agreement;
        }

        if (entry.organization && (!this.vendorId || own_ule)) {
          this.vendor = entry.organization;
          this.vendorId = entry.organization.id;
          let vendor = entry.organization;
          if (vendor) {
            this.$nextTick(() => {
              if (this.$refs.autocomplete) {
                this.$refs.autocomplete.value = vendor.organization_name;
              }
            });
          }
        }

        if (entry.account_number && (!this.accountNumber || own_ule)) {
          this.accountNumber = entry.account_number;
          this.accountNumberConfirmation = entry.account_number;
        }
      });

      this.onNeedAssistanceChange()
    },

    getValueForMonth(month, field) {
      let key = month
      if (typeof(month) == 'object') {
        key = month.format(this.monthFormat)
      }
      if (this.monthInputs[key] !== undefined) {
        let returnValue = this.monthInputs[key][field]
          ? this.monthInputs[key][field]
          : 0;
        return returnValue;
      }
      return 0;
    },

    getArrayValueForMonth(month, field) {
      if (this.monthInputs[month.format(this.monthFormat)] !== undefined) {
        return this.monthInputs[month.format(this.monthFormat)][field]
          ? this.monthInputs[month.format(this.monthFormat)][field]
          : [];
      }
      return [];
    },

    updateValueForMonth(month, field, value) {
      let key = month
      if (typeof(month) == 'object') {
        key = month.format(this.monthFormat)
      }
      if (this.type.pivot.type == 2 && !this.flatFeeLimitValid) {
        UIkit.modal.alert(
          "The maximum fee amount for this assistance type is $" +
            Math.max(this.programFlatFeeLimit, this.maxFlatFeeLimit) +
            ". We have adjusted your fee amount accordingly. "
        );

        this.$delete(this.monthInputs, key);
        this.onAddLedgerEntry()
        return;
      }

      if (value === "") value = 0;
      value = parseFloat(value);
      if (field === "fees") {
        let maxAmount = this.type.pivot.max_fee_amount;
        if (maxAmount !== null && value > parseFloat(maxAmount)) {
          UIkit.modal.alert(
            "The maximum fee amount for this assistance type is $" +
              maxAmount +
              ". We have adjusted your fee amount accordingly. "
          );
          value = maxAmount;
        }
      }

      if (this.monthInputs[key] === undefined) {
        this.$set(this.monthInputs, key, {
          amount: 0,
          fees: 0,
          paid: 0,
          alternative_funding_programs: [],
          approved: 0,
          own_ule: true,
        });
      }
      this.monthInputs[key][field] = parseFloat(value);

      this.$emit("updated", this.monthInputs);
    },

    getRequestedAssistanceForMonth(month) {
      let monthInput = this.monthInputs[month.format(this.monthFormat)];
      if (monthInput !== undefined) {
        let amount = parseFloat(monthInput.amount) + parseFloat(monthInput.fees) - parseFloat(monthInput.paid);

        if (monthInput.alternative_funding_programs && monthInput.alternative_funding_programs.length) {
          _.each(monthInput.alternative_funding_programs, (afp) => {
            if (afp.pivot.amount) {
              amount -= parseFloat(afp.pivot.amount);
            }
          });
        }

        return amount;
      }
      return 0;
    },

    addAssistance(programs) {
      programs.push({
        pivot: {
          alternative_funding_program_id: null,
          amount: 0,
        },
      });
    },

    getMonthInputs() {
      return this.monthInputs;
    },

    getHouseholdMemberId() {
      return this.hhMemberId;
    },

    getDisconnectStatusId() {
      return this.disconnectStatusId;
    },

    getVendorId() {
      return this.vendorId;
    },

    getVendorName() {
      if (this.$refs.autocomplete) {
        return this.$refs.autocomplete.value;
      }
    },

    getAccountNumber() {
      return this.accountNumber;
    },

    clearAssistance() {
      // this.monthInputs = [];
      // this.checkedMonths = [];
    },

    futureMonths() {
      // let now = moment();
      // let end = moment(this.program.assistance_end);
      // return Math.round((end - now) / 2692000000); //convert to months
      if (this.type.pivot.additional_months) {
        return parseInt(this.type.pivot.additional_months);
      }
      return parseInt(this.programSettings["ledger-entry-future-months"]);
    },

    async validate() {
      this.errors = {};

      let billPayIdDisabled = this.programSettings["disable-who-pays-this-bill-option"];

      if (this.needsAssistance) {
        let billPayIdDisabled = this.programSettings["disable-who-pays-this-bill-option"];

        // If the type is Ledger (Simplified), we need to automatically set the household member
        // to the first HHM of the application
        if (this.type.pivot.type === TYPE_LEDGER_SIMPLIFIED || billPayIdDisabled) {
          this.hhMemberId = this.application.household.members[0].id;
        }

        if (!this.hhMemberId) {
          this.errors["hhMemberId"] = ["You must select who pays this bill."];
        }

        if (this.type.is_utility && this.type.pivot.type !== TYPE_LEDGER_NO_DISCONNECT && this.type.pivot.type !== TYPE_LEDGER_SIMPLIFIED) {
          if (this.showDisconnect && !this.disconnectStatusId) {
            this.errors["disconnectStatusId"] = ["You must make a selection."];
          }

          if (!this.vendorId && !this.$refs.autocomplete.value && this.type.pivot.type !== TYPE_LEDGER_SIMPLIFIED) {
            this.errors["vendorId"] = ["You must select a vendor."];
          }

          if (!this.accountNumber) {
            this.errors["accountNumber"] = ["You must enter an account number."];
          }

          if (this.accountNumber !== this.accountNumberConfirmation) {
            this.errors["accountNumberConfirmation"] = ["Your account numbers must match."];
          }
        }

        if(this.type.key == 'mortgage') {
          if (!this.vendorId && !this.$refs.autocomplete.value) {
            this.errors["vendorId"] = ["You must select a vendor."];
          }

          if (!this.accountNumber) {
            this.errors["accountNumber"] = ["You must enter an account number."];
          }

          if (this.accountNumber !== this.accountNumberConfirmation) {
            this.errors["accountNumberConfirmation"] = ["Your account numbers must match."];
          }
        }

        if (this.showAlternativeFunding) {
          // this.errors = {}; // Commented this out because it was resetting ALL validation above it. -Justin 3/30/22
          this.months.forEach((month, key) => {
            if (this.monthInputs[month.format(this.monthFormat)]) {
              this.monthInputs[month.format(this.monthFormat)].alternative_funding_programs.forEach((program, id) => {
                if (!program.pivot.alternative_funding_program_id) {
                  this.errors[`month_${key}_program_${id}_alternative_fund`] = ["You must select an option."];
                }
              });
            }
          });
        }

        if(this.type.pivot.max_assistance && this.totalRequested > this.type.pivot.max_assistance) {
          this.errors["total_request"] = ["Your requested amount is more than the maximum allowed of " + accounting.formatMoney(this.type.pivot.max_assistance)];
        }

        if (this.totalRequested == 0 && this.type.pivot.type === 1) {
          if (this.type.key == "rent" && this.programSettings["ami-blocks-rent-entries"] === true) {
            // do not block
          } else {
            // Count entries from previous applications.  If there are any, do not block
            let previousEntryCount = _.filter(this.monthInputs, (input) => input.own_ule === false).length;
            if (previousEntryCount === 0) {
              this.errors["total_request"] = ["You must check at least one option above."];
            }
          }
        }
      }

      console.log('LedgerEntriesForType errors', JSON.parse(JSON.stringify(this.errors)));
      return this.errors;
    },

    async openHistory() {
      this.$refs.historyModal.open();
    },

    getTotalAlternativeFunding() {
      let amount = 0;
      for(let i in this.monthInputs) {
        let monthInput = this.monthInputs[i];
        if(monthInput.alternative_funding_programs && monthInput.alternative_funding_programs.length) {
          for(let j in monthInput.alternative_funding_programs) {
            let altFunding = monthInput.alternative_funding_programs[j];
            amount = amount + parseFloat(altFunding.pivot.amount);
          }
        }
      }

      return amount;
    },

    isLastEligibleMonth(month) {
      if(this.program.last_eligible_date === this.program.assistance_end) {
        return false;
      }
      return month.format('YYYYMM') == moment(this.program.last_eligible_date).format('YYYYMM');
    }
  },
};
</script>
